export default __webpack_public_path__ + "static/media/registration-custom-fields.d26d6e54.png";